<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-report`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M32 2a2 2 0 012 2v1h5a2 2 0 012 2v36a2 2 0 01-2 2H9a2 2 0 01-2-2V7a2 2 0 012-2h5V4a2 2 0 012-2h16zM14 9h-3v32h26V9h-3v1a2 2 0 01-2 2H16a2 2 0 01-2-2V9zm11 20a1 1 0 011 1v2a1 1 0 01-1 1h-8a1 1 0 01-1-1v-2a1 1 0 011-1h8zm6-9a1 1 0 011 1v2a1 1 0 01-1 1H17a1 1 0 01-1-1v-2a1 1 0 011-1h14zM30 6H18v2h12V6z"/></svg>
</template>
<script>

export default {
  name: 'IconReport',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
